<script>
	export let category
</script>

<details open>
	<summary class="my-4 text-xl">{category.name}</summary>
	<slot indicators={category.indicators} />
</details>
